import React, { useEffect, useState } from 'react'
import { useValues, useActions } from 'kea'

import Actions from './actions'
import Filters from '~/scenes/search/filters-page/filters'

import filtersLogic from '~/scenes/search/filters-page/logic'

export default function SubMenuPopup () {
  const { isSubMenuActive, activeSubMenu } = useValues(filtersLogic)
  const { applyFilter, clearFilter } = useActions(filtersLogic)
  const [pushedPosition, setPushedPosition] = useState(false)
  const [topPosition, setTopPosition] = useState(51)

  useEffect(() => {
    const listener = () => {
      const currentPopup = document.querySelector(`#sub-menu-popup-${activeSubMenu}`)
      const currentButton = document.querySelector(`#header-filter-button-${activeSubMenu}`)

      if (currentPopup && currentButton) {
        const popupPosition = currentPopup.getBoundingClientRect()
        const buttonPosition = currentButton.getBoundingClientRect()

        if (popupPosition.right >= window.innerWidth && !pushedPosition) {
          setPushedPosition(true)
          setTopPosition(buttonPosition.top + 51)
        }

        if (pushedPosition && topPosition !== buttonPosition.top + 51) {
          setTopPosition(buttonPosition.top + 51)
        }

        if (popupPosition.left > buttonPosition.left && pushedPosition) {
          setPushedPosition(false)
          setTopPosition(51)
        }
      }
    }
    listener()

    window.addEventListener('resize', listener)
    return () => {
      window.removeEventListener('resize', listener)
    }
  }, [activeSubMenu, pushedPosition, topPosition])

  if (!isSubMenuActive) {
    return <div />
  }

  return (
    <div
      style={{ top: topPosition }}
      id={`sub-menu-popup-${activeSubMenu}`}
      className={`sub-menu-popup ${pushedPosition ? 'pushed-right' : ''}`}
    >
      <Filters />
      <Actions onApply={() => applyFilter('')} onClear={() => clearFilter(activeSubMenu)} />
    </div>
  )
}
